<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          fab
          x-small
          class="ml-1"
          color="primary"
          :to="`/orders/${encryptIt(orderId)}/order-details`"
        >
          <v-icon small dark>mdi-eye</v-icon>
        </v-btn>
      </template>
      <span>View {{ orderNo }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          fab
          x-small
          class="ml-1"
          color="teal"
          dark
          @click="$emit('invoice', orderId, orderNo)"
        >
          <v-icon small>mdi-file-download-outline</v-icon>
        </v-btn>
      </template>
      <span>Download invoice {{ orderNo }}</span>
    </v-tooltip>
  </span>
</template>

<script>
/** Eye (order details) + invoice (download PDF) for one order on the Sale Linkage page. */
export default {
  name: "SaleLinkageRowActions",
  props: {
    orderId: { type: Number, required: true },
    orderNo: { type: String, default: "" },
  },
};
</script>
